import React, { useState, useEffect, useContext } from "react";
import Fuse from "fuse.js";
import "./Search.css";
import {authContext} from "../../context/authContext";
import {ce_default_url} from '../../context/firebase-config';
import searchData from "../../data/geojson/search_database.json";

const Search = (props) => {
  const { selectedProject } = props;

  const [portfolios, setPortfolios] = useState([]);
  const [selectedPortfolio, setSelectedPortfolio] = useState(portfolios.length === 0 ? "" : portfolios[0]);
  const [layers, setLayers] = useState(JSON.parse(localStorage.getItem("layers")));
  const [search, setSearch] = useState("");
  const [filterKey, setFilterKey] = useState("");
  const [filterData, setFilterData] = useState([]);

  const types = ["demographic", "market", "resilience", "insurance"];

  const user = useContext(authContext);
  useEffect(() => {
    if (selectedProject) {
      user && user.getIdTokenResult()
      .then((token) => {
          if (!!token.claims.api_key) {
              fetch(`${ce_default_url}/api/portfolios`, {
                  method: 'GET',
                  headers: {
                      'X-SustGlobal-APIKey': token.claims.api_key,
                      'X-SustGlobal-Project': selectedProject,
                  }
              })
                  .then(r => r.json())
                  .then(r => {
                    if (!r.errors) {
                      let ports = []
                      r.forEach((p) => {
                          if (p.status === 'Risk data available') {
                              ports.push(p.portfolio_name)
                          }
                      })
                      setPortfolios(ports)
                      if (ports.length !== 0) {
                        setSelectedPortfolio(ports[0])
                      }
                    }
                  })
          } else {
              console.error('api key not available for user')
          }
      })
      .catch((error) => {
          console.error(`[APPS_LIST] Error while fetching portfolio data: ${error}`)
      });
    }
  }, [user, selectedProject]);

  const updateLayer = (layer) => {
    let newLayers = [];

    if (layers.find(l => l.name === layer.name)) {
      newLayers = layers.filter(l => l.name !== layer.name);
    } else {
      newLayers = [...layers, layer];
    }

    localStorage.setItem("layers", JSON.stringify(newLayers));
    setLayers(newLayers);
  }

  useEffect(() => {
    if (!layers) {
      setLayers([]);
    }
  }, [layers]);

  const fuse = new Fuse(searchData, {
    keys: ["name", "type", "resolution", "cadence", "source", "updatedOn", "keywords"],
    threshold: 0.5
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    setFilterKey(search);

    const res = fuse.search(search);
    const formattedRes = [];
    if(res.length){
      res.forEach((item) =>{
        formattedRes.push(item.item);
      });
    }
    setFilterData(formattedRes);
  };
  
  let items = searchData.filter(i => (filterData ? filterData.find(d => d.name === i.name) : false) 
                                    || (layers ? layers.find(l => l.name === i.name) : false)).map(
    (i, index) => {
        return (
          <tr key={i.name}>
            <td className="align-middle">
              <button type="submit" className="import-button"
                      onClick={() => updateLayer(i)}
                      style={{width: "100px", fontWeight: 600, background: layers.find(l => l.name === i.name) ? "#ce3d3d" : "black"}}>
                <span>{layers.find(l => l.name === i.name) ? "Remove" : "Import"}</span>
              </button>
            </td>
            <td className="align-middle"><b>{i.name}</b></td>
            <td className="align-middle"><i>{i.resolution}</i></td>
            <td className="align-middle"><i>{i.cadence}</i></td>
            <td className="align-middle">{i.updatedOn}</td>
            <td className="align-middle">{i.source}</td>
            <td className="align-middle"><a href={i.url}>Link</a></td>
          </tr>
        )
    }
  );

  return (
    <div>
      <div id="content" className={"bg-black"}
           style={{maxWidth: "1275px", minWidth: "1275px", margin: "10px auto 0 auto",
                   fontSize: "1rem", fontWeight: "500", lineHeight: "1.5", height: "90vh"}}
      >
        <div style={{width: "70%", marginLeft: "auto", marginRight: "auto"}}>
          <h3 className={"modal-title"}
            style={{color: "#ffffff", fontWeight: "550", fontSize: "1.6rem"}}>Dataset Search</h3>
          <hr />

          <div style={{overflow: "scroll", msOverflowStyle: 'none', scrollbarWidth: 'none',
                       WebkitScrollbar: { display: 'none' }, height: "65vh", backgroundColor: "transparent"}}>
          {items.length !== 0 && (<table className={"table table-dark"} style={{backgroundColor: "black"}}>
            <thead style={{borderBottomColor: "black"}}>
              <tr>
                <th width="30px"></th>
                <th>Dataset Name</th>
                <th>Spatial Resolution</th>
                <th>Refresh Rate</th>
                <th>Last Updated</th>
                <th>Source</th>
                <th>URL</th>
              </tr>
            </thead>
            <tbody>
            {items}
            </tbody>
          </table>) }
          </div>

          <div style={{position: "absolute", bottom: "10%",
                       display: "flex", flexDirection: "row", gap: "10px"}}>
            <form onSubmit={handleSubmit}>
              <label>
                <input type="text" style={{width: "750px", background: "#E8E8E8"}}
                       placeholder="Search here to add new datasets to the Visual Summary dashboard"
                       value={search} onChange={(e) => setSearch(e.target.value)} />
              </label>
              <input type="submit" className="search-button" 
                     style={{width: "100px", fontWeight: 600, marginLeft: "20px"}} value="Search" />
            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Search;
